export default __webpack_public_path__ + "static/media/job_offer12_xl.94c1852e.jpg";